import { render, staticRenderFns } from "./PayOnDemandModal.vue?vue&type=template&id=f308d380&"
import script from "./PayOnDemandModal.vue?vue&type=script&lang=js&"
export * from "./PayOnDemandModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports